import { InjectionToken } from '@angular/core';
import type { GoogleMapsConfig } from './google-maps.interface';

export const GOOGLE_MAPS_CONFIG = new InjectionToken<GoogleMapsConfig>(
  'GoogleMapsConfig',
);

export const SSR_MAPS_API_KEY = new InjectionToken<string>('SSR_MAPS_API_KEY');
